export { default } from './Ellipsis';
export * from './Ellipsis';
